<template>
    <Dialog v-model:open="opened">
        <DialogTrigger> <slot /> </DialogTrigger>
        <DialogContent class="max-w-2xl">
            <DialogHeader>
                <DialogTitle>{{ $t("bookings.detail") }}</DialogTitle>
            </DialogHeader>

            <div class="max-h-[calc(100vh-250px)] overflow-y-scroll">
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead>
                                {{ $t("event_types.booking_form.label") }}
                            </TableHead>
                            <TableHead>
                                {{ $t("event_types.booking_form.value") }}
                            </TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        <TableRow v-if="reservation.firstname">
                            <TableCell class="font-medium">
                                {{ $t("bookings.details.first_name") }}
                            </TableCell>
                            <TableCellWithCopy :value="reservation.firstname" />
                        </TableRow>
                        <TableRow v-if="reservation.lastname">
                            <TableCell class="font-medium">
                                {{ $t("bookings.details.last_name") }}
                            </TableCell>
                            <TableCellWithCopy :value="reservation.lastname" />
                        </TableRow>
                        <TableRow v-if="reservation.phone">
                            <TableCell class="font-medium">
                                {{ $t("bookings.details.phone") }}
                            </TableCell>
                            <TableCellWithCopy :value="reservation.phone" />
                        </TableRow>

                        <TableRow v-if="reservation.location">
                            <TableCell class="font-medium">
                                {{ $t("bookings.details.location") }}
                            </TableCell>
                            <TableCellWithCopy
                                :value="reservation.location.value"
                            />
                        </TableRow>

                        <p class="mt-6 font-bold">
                            {{ $t("bookings.details.custom_fields") }}
                        </p>
                        <TableRow
                            v-for="(field, i) of reservation.customFieldValues"
                            :key="i"
                        >
                            <TableCell class="font-medium">
                                {{ field.label }}
                            </TableCell>
                            <TableCellWithCopy :value="fieldValue(field)" />
                        </TableRow>
                    </TableBody>
                </Table>
            </div>
            <DialogFooter>
                <Button @click="opened = false"> {{ $t("close") }}</Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script lang="ts" setup>
import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTrigger,
} from "@/components/ui/dialog";
import { ref } from "vue";
import type { Reservation } from "./event.vue";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
    TableCellWithCopy,
} from "@/components/ui/table";
import DialogTitle from "@/components/ui/dialog/DialogTitle.vue";
import { useI18n } from "vue-i18n";
import { PerfectScrollbar } from "vue3-perfect-scrollbar";

const opened = ref(false);
const { t } = useI18n();

function fieldValue(field: any): string {
    if (field.type === "checkbox") {
        return field.value ? t("yes") : t("no");
    }

    if (field.value.startsWith("[") && field.value.endsWith("]")) {
        return JSON.parse(field.value).join(", ");
    }
    return field.value;
}

const props = defineProps<{
    reservation: Reservation;
}>();
</script>
